import { vuexPto } from '@/store/compositionV2/module/pto'
import { PTOJobApi } from '@/api/pto'
import { getYesOrNo } from '@/utils/string/getYesOrNo'
import { getUserFullName } from '@/utils/user'
import { priceFormat } from '@/utils/form/priceFormat'

const state = () => ({
  ...vuexPto.createState(),
  api: PTOJobApi,
  namePageDetailed: 'PtoProjectPtoJobUpdate',
  expand: 'job_type,executor,executor_contract,treaty,measure_unit,project,planning',
  tableHeaders: [
    {
      title: 'Дата обновления',
      isSortable: true,
      sortName: 'updated_at'
    },
    {
      title: 'Вид работ',
      isSortable: true,
      sortName: 'job_type.name'
    },
    {
      title: 'Описание',
      isSortable: false,
      sortName: 'description'
    },
    {
      title: 'Объем работ',
      isSortable: true,
      sortName: 'work_scope'
    },
    {
      title: 'Ед. изм.',
      isSortable: true,
      sortName: 'measure_unit.name'
    },
    {
      title: 'МОЛ',
      isSortable: true,
      sortName: ''
    },
    {
      title: 'Дата начала работ',
      isSortable: true,
      sortName: 'start_date'
    },
    {
      title: 'Дата окончания',
      isSortable: true,
      sortName: 'stop_date'
    },
    {
      title: 'Стоимость',
      isSortable: true,
      sortName: 'price'
    },
    {
      title: 'Примечание',
      isSortable: false,
      sortName: 'note'
    },
    {
      title: 'Исполнитель',
      isSortable: false,
      sortName: ''
    },
    {
      title: 'ГП к получению',
      isSortable: true,
      sortName: 'general_contract'
    },
    {
      title: 'Договор',
      isSortable: true,
      sortName: 'treaty.treaty_number'
    },
    {
      title: 'Запланировано равномерно',
      isSortable: false,
      sortName: 'is_plan_evenly'
    }
  ]
})

const getters = {
  ...vuexPto.createGetters(),
  getList: state => {
    return state.list.map(item => {
      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.updated_at || '-',
          item.job_type?.name || '-',
          { data: item.description || '-', mod: 'comments' },
          priceFormat(item.work_scope) || '-',
          item.measure_unit?.name || '-',
          getYesOrNo(item.is_mol),
          item.start_date || '-',
          item.stop_date || '-',
          priceFormat(item.price) || '-',
          { data: item.note || '-', mod: 'comments' },
          getUserFullName(item.executor) || item.executor_contract?.long_name || '-',
          item.general_contract || '-',
          item.treaty?.treaty_number || '-',
          getYesOrNo(item.is_plan_evenly)
        ]
      }
    })
  }
}

const mutations = {
  ...vuexPto.createMutations()
}

const actions = {
  ...vuexPto.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
